import { useState, useEffect, useCallback } from 'react'
import ApiPlayers from '../../../../api/ApiPlayers'
import services from '../../../../services'
import { MATCH_STATUS } from '../../../../utils/matchStatus'

export default function usePlayerHistoryData(playerId) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [playerHistory, setPlayerHistory] = useState(null)

  const fetchPlayerHistory = useCallback(async () => {
    try {
      setLoading(true)
      const history = await ApiPlayers.getHistory(playerId)

      try {
        const normalMatchIds = (history?.leagues || [])
          .flatMap((ld) => ld.matches || [])
          .filter((m) => m.status === MATCH_STATUS.NORMAL)
          .map((m) => m.id)

        if (normalMatchIds.length > 0) {
          const scoresResponse =
            await services.match.bulkGetScores(normalMatchIds)
          if (scoresResponse?.success && scoresResponse.data?.scores) {
            const scoresMap = scoresResponse.data.scores
            history.leagues = history.leagues.map((ld) => ({
              ...ld,
              matches: (ld.matches || []).map((match) =>
                scoresMap[match.id]
                  ? { ...match, set_scores: scoresMap[match.id].scores || [] }
                  : match,
              ),
            }))
          }
        }
      } catch (scoreErr) {
        // Score enrichment is best-effort; player history is still usable without it.
        console.warn(
          'Could not load match scores for player history:',
          scoreErr,
        )
      }

      setPlayerHistory(history)
    } catch (err) {
      console.error('Error fetching player history:', err)
      setError('Failed to load player history. Please try again later.')
    } finally {
      setLoading(false)
    }
  }, [playerId])

  useEffect(() => {
    if (playerId) {
      fetchPlayerHistory()
    }
  }, [fetchPlayerHistory, playerId])

  return { loading, error, playerHistory, fetchPlayerHistory }
}
